import { AppRoutes } from 'containers/App/routes';
import { systemBaseRoute } from 'cb-utils/consoleRouteUtils';

export const notificationHistoryRoot = 'notificationHistory';
export const notificationHistoryRoute = `${AppRoutes.CONSOLE_BASE_ROUTE}${systemBaseRoute}/${notificationHistoryRoot}`;
